import { useState } from "react";
import { Badge, Col, Row } from "react-bootstrap";
import { CommonSelect } from "../../Input";
import DataTable from "../../table/DataTable";

// Import bill images
import bill1000 from "../../../../images/cash/100_dollar.png"; // reusing
import bill100 from "../../../../images/cash/100_dollar.png";
import bill50 from "../../../../images/cash/50_dollar.png";
import bill20 from "../../../../images/cash/20_dollar.png";
import bill10 from "../../../../images/cash/10_dollar.png";
import bill5 from "../../../../images/cash/5_dollar.png";
import bill2 from "../../../../images/cash/1_dollar.png";
import bill1 from "../../../../images/cash/1_dollar.png";
import coin50c from "../../../../images/cash/50_cents.png";
import coin20c from "../../../../images/cash/25_cents.png"; // Fallback
import coin10c from "../../../../images/cash/10_cents.png";
import coin5c from "../../../../images/cash/5_cents.png";

const Step4Denomination = () => {
  const [inQuantities, setInQuantities] = useState({});
  const [outQuantities, setOutQuantities] = useState({});

  const denominations = [
    { id: "bill1000", label: "1000 Dollars", value: 1000, image: bill1000 },
    { id: "bill100", label: "100 Dollars", value: 100, image: bill100 },
    { id: "bill50", label: "50 Dollars", value: 50, image: bill50 },
    { id: "bill10", label: "10 Dollars", value: 10, image: bill10 },
    { id: "bill5", label: "5 Dollars", value: 5, image: bill5 },
    { id: "bill2", label: "2 Dollars", value: 2, image: bill2 },
    { id: "bill1", label: "1 Dollar", value: 1, image: bill1 },
    { id: "coin50c", label: "50 Cents", value: 0.5, image: coin50c },
    { id: "coin20c", label: "20 Cents", value: 0.2, image: coin20c },
    { id: "coin10c", label: "10 Cents", value: 0.1, image: coin10c },
    { id: "coin5c", label: "5 Cents", value: 0.05, image: coin5c },
  ];

  const handleInChange = (id, val) =>
    setInQuantities({ ...inQuantities, [id]: parseInt(val) || 0 });
  const handleOutChange = (id, val) =>
    setOutQuantities({ ...outQuantities, [id]: parseInt(val) || 0 });

  const getColumns = (type, quantities, onChange) => [
    {
      label: "IMAGE",
      key: "image",
      className: "ps-4",
      render: (item) => (
        <div
          className="d-flex align-items-center justify-content-center border rounded bg-white overflow-hidden"
          style={{ width: "45px", height: "30px", borderColor: "#eee" }}
        >
          {item.image ? (
            <img
              src={item.image}
              alt={item.label}
              style={{ width: "100%", height: "auto" }}
            />
          ) : (
            <div className="text-muted fs-8 fw-bold">$</div>
          )}
        </div>
      ),
    },
    {
      label: "DENOMINATION",
      key: "label",
      render: (item) => (
        <span className="fs-12 fw-medium text-black">{item.label}</span>
      ),
    },
    ...(type === "out"
      ? [
          {
            label: "INVENTORY",
            key: "inventory",
            render: () => (
              <div className="d-flex align-items-center">
                <div
                  className="rounded-circle me-1"
                  style={{
                    width: "6px",
                    height: "6px",
                    backgroundColor: "#34D399",
                  }}
                ></div>
                <span className="text-muted fs-11">100</span>
              </div>
            ),
          },
        ]
      : []),
    {
      label: "QUANTITY",
      key: "quantity",
      render: (item) => (
        <input
          type="number"
          className="form-control text-center py-1"
          style={{
            height: "30px",
            width: "70px",
            fontSize: "12px",
            borderColor: "#E2E8F0",
          }}
          value={quantities[item.id] || ""}
          placeholder="0"
          onChange={(e) => onChange(item.id, e.target.value)}
        />
      ),
    },
    {
      label: "TOTAL",
      key: "total",
      className: "pe-4",
      render: (item) => (
        <div className="text-end fw-bold fs-12 text-black">
          SGD {(item.value * (quantities[item.id] || 0)).toFixed(2)}
        </div>
      ),
    },
  ];

  return (
    <div className="mt-2 pb-2">
      <div
        className="bg-white p-3 mb-4 border"
        style={{ borderRadius: "12px" }}
      >
        <Row className="g-3">
          <Col md={3}>
            <label className="text-muted fs-11 mb-2 d-block">
              Payment Method
            </label>
            <CommonSelect
              placeholder="Cash"
              options={[{ value: "cash", label: "Cash" }]}
            />
          </Col>
          <Col md={4}>
            <label className="text-muted fs-11 mb-2 d-block">Total Paid</label>
            <div className="input-group">
              <span className="input-group-text bg-light fs-12 text-muted px-2">
                SGD
              </span>
              <input
                type="text"
                className="form-control fs-14 py-2"
                value="9"
              />
            </div>
          </Col>
          <Col md={4}>
            <label className="text-muted fs-11 mb-2 d-block">
              Change Amount
            </label>
            <div className="input-group">
              <span className="input-group-text bg-light fs-12 text-muted px-2">
                SGD
              </span>
              <input
                type="text"
                className="form-control fs-14 py-2"
                value="0.00"
                readOnly
              />
            </div>
          </Col>
        </Row>
      </div>

      <Row className="g-4">
        <Col lg={6}>
          <div
            className="bg-white p-3 mb-3 border d-flex flex-column justify-content-center"
            style={{ height: "80px", borderRadius: "12px" }}
          >
            <div className="text-muted fs-11 fw-bold mb-1">
              Actual Cash Receive
            </div>
            <div className="fw-bold fs-18 text-primary">SGD 0</div>
          </div>
          <div className="card border-0 shadow-sm rounded-4 overflow-hidden border border-light">
            <DataTable
              columns={getColumns("in", inQuantities, handleInChange)}
              data={denominations}
              showPagination={false}
              minWidth="100%"
            />
          </div>
        </Col>

        <Col lg={6}>
          <div
            className="bg-white p-3 mb-3 border d-flex align-items-center"
            style={{ height: "80px", borderRadius: "12px" }}
          >
            <Row className="g-2 w-100">
              {[
                { label: "Cash Transfer Amount:", value: "9 SGD" },
                { label: "Actual Cash Receive:", value: "0 SGD" },
                {
                  label: "Expected Change:",
                  value: "0 SGD",
                  extra: (
                    <Badge
                      bg="success"
                      className="ms-2 rounded-pill bg-opacity-10 text-success fw-bold p-1 px-2"
                      style={{ fontSize: "9px" }}
                    >
                      Rounded
                    </Badge>
                  ),
                },
                { label: "Actual Change:", value: "SGD 0" },
              ].map((item, id) => (
                <Col md={6} key={id}>
                  <div className="d-flex justify-content-between align-items-center p-1 px-2">
                    <span className="text-muted fs-10">{item.label}</span>
                    <div className="d-flex align-items-center">
                      <span className="fw-bold text-black fs-12">
                        {item.value}
                      </span>
                      {item.extra}
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
          <div className="card border-0 shadow-sm rounded-4 overflow-hidden border border-light">
            <DataTable
              columns={getColumns("out", outQuantities, handleOutChange)}
              data={denominations}
              showPagination={false}
              minWidth="100%"
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Step4Denomination;
